import {Pattern} from '@domain/pattern';
import {PatternVisualisation} from '@domain/pattern-visualisation';
import {AssertionUtils} from '@vdw/angular-component-library';

export class CutbarPattern extends Pattern {
  public constructor(
    id: number,
    name: string,
    visualisations: PatternVisualisation[],
    type?: string,
    comment?: string,
    heightInPixels?: number,
    widthInPixels?: number,
    sizeInBytes?: number,
    dateCreated?: Date,
    xSizeInDents?: number,
    xSizeInFrames?: number,
    ySizeInColorlines?: number,
    ySizeInPicks?: number,
    weavingChores?: number[]
  ) {
    super(id, name, visualisations, type, comment, heightInPixels, widthInPixels, sizeInBytes, dateCreated, xSizeInDents, xSizeInFrames, ySizeInColorlines, ySizeInPicks, weavingChores);
  }

  public static fromJSON(cutbarPatternJSON: any): CutbarPattern {
    if (AssertionUtils.isNullOrUndefined(cutbarPatternJSON)) {
      return null;
    }

    const pattern = super.fromJSON(cutbarPatternJSON) as CutbarPattern;

    return new CutbarPattern(
      pattern.id,
      pattern.name,
      pattern.visualisations,
      pattern.type,
      pattern.comment,
      pattern.heightInPixels,
      pattern.widthInPixels,
      pattern.sizeInBytes,
      pattern.dateCreated,
      pattern.xSizeInDents,
      pattern.xSizeInFrames,
      pattern.ySizeInColorlines,
      pattern.ySizeInPicks,
      pattern.weavingChores
    );
  }
}
